<template>
    <coach-seat-layout 
        v-on:childToParent="onSeatSelectionInChild"
        v-bind:sale="sale"
        v-bind:events="events"
    />
</template>

<script>
    Vue.component('coach-seat-layout', require('../tickets/CoachSeatLayout'));

    export default {
        name: "coach-seat-selection",
        components: {},
        props: [
            'available_seats',
            'selected_seat',
            'events',
            'sale',
            'user'
        ],
        created() {
        },
        destroyed() {
        },
        mounted() {
        },
        data() {
            return {
                number_of_coaches: 0,
                seats_unavailable: [],
                user_assets_group: $user
            }

        },
        methods: {
            onSeatSelectionInChild(seat)  {
                // console.log('Emit received in coachSeatSelection ', seat)
                this.$emit('childToParent', seat)
            },
        },
        computed: {
        }
    }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/assets/js/components/tickets/CoachSeatSelection.vue